import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import {action, observable, runInAction} from 'mobx';
import debounce from 'lodash/debounce';
import './bpmCalculator.scss';
import {ReactComponent as LeftArrow} from "../../../assets/images/studio/CarretLeft.svg";
import classNames from "classnames";
import FormattedMessageCapitalized from "../../../components/FormattedMessageCapitalized";

@observer
class BpmCalculator extends Component {
    @observable isStartedSession = false;
    @observable isFirstSession = false;
    @observable isStartedCalculate = false;
    @observable bpm = 0;
    @observable averageTapDelta = 0;
    numTaps = 0;
    @observable lastTap;
    @observable trigger;
    @observable activeClass = false;

    componentDidMount() {
        this.debounceSessionTrigger = debounce(this.triggerSession, 3000);
        document.addEventListener('keypress', this.onKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener('keypress', this.onKeyPress);
        this.props.stop();
    }

    onKeyPress = (e) => {
        if (e.which === 32 && !['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
            this.beat();
        }
    };

    @action triggerActiveClass = () => {
        this.activeClass = true;
        setTimeout(() => {
            runInAction(() => {
                this.activeClass = false;
            });
        }, 100);
    };

    @action triggerSession = () => {
        const {play, stop, onCalculateBpm} = this.props;
        this.isStartedSession = !this.isStartedSession;
        if (this.isStartedSession) {
            play();
            this.isFirstSession = true;
            this.isStartedCalculate = false;
            this.bpm = 0;
            this.averageTapDelta = 0;
            this.numTaps = 0;
            this.trigger.blur();
        } else {
            stop();
            onCalculateBpm(this.bpm);
            this.debounceSessionTrigger.cancel();
        }
    };

    @action beat = () => {
        if (!this.isStartedSession) return;
        if (!this.isStartedCalculate) {
            this.lastTap = Date.now();
            this.isStartedCalculate = true;
            return;
        }
        const tap = Date.now();
        const delta = tap - this.lastTap;
        // if (delta < 85) return;
        this.averageTapDelta = Math.round(((this.averageTapDelta * this.numTaps) + delta) / (this.numTaps + 1));
        this.bpm = Math.round(60000 / this.averageTapDelta);
        this.numTaps += 1;
        this.lastTap = tap;
        this.debounceSessionTrigger();
        this.triggerActiveClass();
    };

    @action setTriggerRef = (button) => {
        this.trigger = button;
    };

    renderControlButtons = () => {
        return <>
            <button
                className={this.isStartedSession ? 'bpm-calculator-btn started' : 'bpm-calculator-btn not-started'}
                ref={this.setTriggerRef} onClick={this.triggerSession}>
                <FormattedMessage id={`upload.bpmCalculator.${this.isStartedSession ? 'end' : this.isFirstSession ? 'startAgain' : 'start'}`}/>
            </button>
            {!this.isStartedSession && this.isFirstSession && <button className='bpm-calculator-btn done' onClick={this.props.toggleBpm}>
                <FormattedMessage id='general.done'/>
            </button>}
        </>
    }

    render() {
        const {isRecordingFlow} = this.props;
        const bpmCalculatorClasses = classNames({
            "bpm-calculator": true,
            "recorded-flow": this.props.isRecordingFlow
        })
        return (
            <div className={bpmCalculatorClasses}>
                <div className="bpm-calculator-holder">
                    {isRecordingFlow ? <div className='recorder-header advanced'>
                        <button className='recorder-back-button'>
                            <LeftArrow onClick={this.props.toggleBpm}/>
                        </button>
                        <FormattedMessageCapitalized id={'upload.recorder.setBPM'} />
                    </div> : <button className="bpm-calculator-close" onClick={this.props.toggleBpm}>
                        <Close/>
                    </button>}
                    <div className="info-area">
                        {!isRecordingFlow && <h3 className="bpm-calculator-title">
                            <FormattedMessage id="upload.bpmCalculator.title"/>
                        </h3>}
                        <p className="bpm-calculator-descr">
                            <FormattedMessage id="upload.bpmCalculator.desk"/>
                        </p>
                        {
                            !isRecordingFlow && this.renderControlButtons()
                        }


                    </div>
                    {this.isFirstSession &&
                    <div className={this.activeClass ? 'tap-area active' : 'tap-area'} onClick={this.beat}>
                        <div className="shadow"/>
                        <div className="tap"/>
                        <div className="name">
                            <FormattedMessage id={`upload.bpmCalculator.${this.isStartedCalculate && this.bpm ? 'name' : 'nameBy'}`}/>
                        </div>
                        <div className="bpm">{this.isStartedCalculate && this.bpm ? this.bpm : <FormattedMessage id="upload.bpmCalculator.tap"/>}</div>
                    </div>
                    }
                    <div className='bpm-recorded-buttons'>
                        {isRecordingFlow && this.renderControlButtons()}
                    </div>
                </div>
            </div>
        );
    }
}

export default BpmCalculator;
